/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".icon_efc05772{display:block;overflow:visible}\n"}]);
export const icon = "icon_efc05772";